<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<fab-loading-spinner [hidden]="!showSpinner"></fab-loading-spinner>

<div id="header-container">
  <div>
    <h1 id="header-text">{{ obsoleteRecordsInput.headerMessage }}</h1>
  </div>
  <div>
    <button class="action-button" color="warn" id="delete-button" mat-raised-button
            (click)="onDelete()"
            [disabled]="noData">
      Delete All
    </button>
  </div>
</div>

<!-- Display message if there is no data -->
<div [hidden]="!noData">{{ obsoleteRecordsInput.noDataMessage }}</div>

<!-- Main Table -->
<div class="gfs-table" *ngIf="!noData">
  <ag-grid-angular
    style="height: 100%; width:100%;"
    class="ag-theme-quartz"
    [rowData]="obsoleteRecords"
    [columnDefs]="columnDefs"
    [autoSizeStrategy]="autoSizeStrategy"
  ></ag-grid-angular>
</div>
